import { render, staticRenderFns } from "./instagramIcon.vue?vue&type=template&id=5101adb8&scoped=true&"
import script from "./instagramIcon.vue?vue&type=script&lang=ts&"
export * from "./instagramIcon.vue?vue&type=script&lang=ts&"
import style0 from "./instagramIcon.vue?vue&type=style&index=0&id=5101adb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5101adb8",
  null
  
)

export default component.exports